"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var word_probability_1 = require("./word-probability");
function generateFakeWordWithUnexpectedLength(maxSeqN, randomGenerator) {
    if (maxSeqN === void 0) { maxSeqN = 4; }
    if (randomGenerator === void 0) { randomGenerator = Math.random; }
    var ch = "^";
    var fakeWord = "";
    var chrs = [];
    while (ch !== "END") {
        chrs = chrs.concat([ch]);
        if (chrs.length > maxSeqN) {
            chrs = chrs.slice(1);
        }
        var nextAccumedProbs = void 0;
        var n = 0;
        do {
            var str = chrs.slice(n).join("");
            nextAccumedProbs = word_probability_1.wordProbability[str];
            n += 1;
        } while (nextAccumedProbs === undefined && n < chrs.length);
        var nextCh = "";
        var r = randomGenerator();
        for (var _i = 0, nextAccumedProbs_1 = nextAccumedProbs; _i < nextAccumedProbs_1.length; _i++) {
            var x = nextAccumedProbs_1[_i];
            var candidateNextCh = x[0];
            var prob = x[1];
            if (r <= prob) {
                nextCh = candidateNextCh;
                break;
            }
        }
        if (nextCh !== "END") {
            fakeWord += nextCh;
        }
        ch = nextCh;
    }
    return fakeWord;
}
exports.generateFakeWordWithUnexpectedLength = generateFakeWordWithUnexpectedLength;
function generateFakeWordByLength(length, maxSeqN, randomGenerator) {
    if (maxSeqN === void 0) { maxSeqN = 4; }
    if (randomGenerator === void 0) { randomGenerator = Math.random; }
    return __awaiter(this, void 0, void 0, function () {
        var fakeWord;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fakeWord = "";
                    _a.label = 1;
                case 1:
                    if (!(fakeWord.length != length)) return [3, 3];
                    return [4, new Promise(function (resolve) {
                            resolve(generateFakeWordWithUnexpectedLength(maxSeqN, randomGenerator));
                        })];
                case 2:
                    fakeWord = _a.sent();
                    return [3, 1];
                case 3: return [2, fakeWord];
            }
        });
    });
}
exports.generateFakeWordByLength = generateFakeWordByLength;
function generateFakeWord(minLength, maxLength, maxSeqN, randomGenerator) {
    if (minLength === void 0) { minLength = 4; }
    if (maxLength === void 0) { maxLength = 9; }
    if (maxSeqN === void 0) { maxSeqN = 2; }
    if (randomGenerator === void 0) { randomGenerator = Math.random; }
    return __awaiter(this, void 0, void 0, function () {
        var fakeWord;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fakeWord = "";
                    _a.label = 1;
                case 1:
                    if (!!(minLength <= fakeWord.length && fakeWord.length <= maxLength)) return [3, 3];
                    return [4, new Promise(function (resolve) {
                            resolve(generateFakeWordWithUnexpectedLength(maxSeqN, randomGenerator));
                        })];
                case 2:
                    fakeWord = _a.sent();
                    return [3, 1];
                case 3: return [2, fakeWord];
            }
        });
    });
}
exports.generateFakeWord = generateFakeWord;
//# sourceMappingURL=index.js.map